<template>
  <div class="overlay" @click.self="handleOverlayClick">
    <div class="shipping-editor">
      <h3 class="text-xl text-center mb-6">{{ title }}</h3>
      <form>
        <div class="container mx-auto">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div class="colA">
              <div class="input-group">
                <label for="ship_date">Ship Date</label>
                <input type="date" id="ship_date" v-model="form.ship_date" />
              </div>
              <div class="input-group">
                <label for="lot_num">Lot No</label>
                <input type="text" id="lot_num" v-model="form.lot_num" />
              </div>
              <div class="input-group">
                <label for="customer">Customer</label>
                <input
                  type="text"
                  id="customer"
                  class="w-full"
                  v-model="form.customer"
                />
              </div>
              <div class="input-group">
                <label for="head_in">Head In</label>
                <input type="text" id="head_in" v-model="form.head_in" />
              </div>
              <div class="input-group">
                <label for="avg_wt_in">Avg Wt In</label>
                <input type="text" id="avg_wt_in" v-model="form.avg_wt_in" />
              </div>
              <div class="input-group">
                <label for="type">Type</label>
                <input type="text" id="type" v-model="form.type" />
              </div>
              <div class="input-group">
                <label for="pasture">Pasture</label>
                <input
                  type="text"
                  id="pasture"
                  class="w-full"
                  v-model="form.pasture"
                />
              </div>
            </div>
            <div class="colB">
              <div class="input-group">
                <label for="destination">Destination</label>
                <input
                  type="text"
                  id="destination"
                  class="w-full"
                  v-model="form.destination"
                />
              </div>
              <div class="input-group">
                <label for="arrival_instructions">Arrival Instructions</label>
                <input
                  type="text"
                  id="arrival_instructions"
                  v-model="form.arrival_instructions"
                />
              </div>
              <div class="input-group">
                <label for="truck_info">Truck Info</label>
                <input type="text" id="truck_info" v-model="form.truck_info" />
              </div>
              <div class="input-group">
                <label for="deads">Deads</label>
                <input type="text" id="deads" v-model="form.deads" />
              </div>
              <div class="input-group">
                <label for="pi">PI</label>
                <input type="text" id="pi" v-model="form.pi" />
              </div>
              <div class="input-group">
                <label for="remarks">Remarks</label>
                <input
                  type="text"
                  id="remarks"
                  class="w-full"
                  v-model="form.remarks"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="editor-actions mt-8">
        <div class="actions-left">
          <button
            class="btn btn-red"
            @click="toggleConfirmDelete"
            v-if="editId && !showConfirmDelete"
          >
            Delete
          </button>
          <p class="mr-2" v-if="showConfirmDelete">
            Please confirm this action:
          </p>
          <button
            class="btn btn-secondary mr-2"
            @click="toggleConfirmDelete"
            v-if="editId && showConfirmDelete"
          >
            Nevermind
          </button>
          <button
            class="btn btn-red"
            @click="handleDelete"
            v-if="editId && showConfirmDelete"
          >
            Confirm Delete
          </button>
        </div>
        <div class="actions-right">
          <button class="btn btn-secondary mr-4" @click="handleOverlayClick">
            Cancel
          </button>
          <button class="btn btn-main" @click="handleCreate" v-if="!editId">
            Create
          </button>
          <button class="btn btn-main" @click="handleUpdate" v-if="editId">
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../database/db.js";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
export default {
  name: "ShippingEditor",
  props: ["editId", "editData"],
  data() {
    return {
      form: {
        ship_date: "",
        lot_num: "",
        customer: "",
        head_in: "",
        avg_wt_in: "",
        type: "",
        pasture: "",
        destination: "",
        arrival_instructions: "",
        truck_info: "",
        deads: "",
        pi: "",
        remarks: "",
      },
      showConfirmDelete: false,
    };
  },
  methods: {
    handleOverlayClick() {
      this.$emit("overlayClick");
    },
    handleKeydown(e) {
      if (e.key === "Escape") this.handleOverlayClick();
    },
    toggleConfirmDelete() {
      this.showConfirmDelete = !this.showConfirmDelete;
    },
    async handleCreate() {
      const mappedForm = {
        ...this.form,
        ship_date: new Date(this.form.ship_date + "T12:00:00.000"),
        created: firebase.firestore.FieldValue.serverTimestamp(),
      };
      try {
        const newRecord = await db.collection("shipping").add(mappedForm);
        this.$emit("recordCreated", newRecord.id);
        this.$toasted.show("New Record Created", {
          type: "success",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toasted.show("Error Adding Record", {
          type: "error",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
    async handleDelete() {
      try {
        await db.collection("shipping").doc(this.editId).delete();
        this.$emit("recordDeleted");
        this.$toasted.show("Record Deleted", {
          type: "success",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toasted.show("Error Deleting Record", {
          type: "error",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
    async handleUpdate() {
      const mappedForm = {
        ...this.form,
        ship_date: new Date(this.form.ship_date + "T12:00:00.000"),
      };
      try {
        await db.collection("shipping").doc(this.editId).set(mappedForm);
        this.$emit("recordUpdated");
        this.$toasted.show("Record Updated", {
          type: "success",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      } catch (e) {
        console.error(e);
        this.$toasted.show("Error Adding Record", {
          type: "error",
          theme: "bubble",
          position: "bottom-center",
          duration: 3000,
        });
      }
    },
  },
  computed: {
    title() {
      return this.editId ? "Edit Shipping Log" : "New Shipping Log";
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
    if (this.editData) {
      const mappedData = {
        ...this.editData,
        ship_date: new Date(this.editData.ship_date?.seconds * 1000)
          .toISOString()
          .split("T")[0],
      };
      delete mappedData.id;
      this.form = mappedData;
    }
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown);
  },
};
</script>

<style lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 100;
  display: flex;
  justify-content: center;
  // Scroll the overlay (not the inner card) so a tall form reaches its
  // buttons on small screens; contain stops scroll-chaining to the page.
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 16px;
}

.shipping-editor {
  // width: 800px;
  margin: auto;
  height: auto;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.267);
  padding: 24px;

  label {
    display: block;
    font-size: 14px;
    font-weight: 500;
    color: #333;
  }

  input {
    width: 100%;
    padding: 5px 8px;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 8px;
    height: 2.25rem;
  }

  .editor-actions {
    display: flex;
    justify-content: space-between;

    .actions-left {
      display: flex;
      align-items: center;
    }
  }
}
</style>
